
/**
 * Normalizes amount values for forms, similar to transaction normalization
 */
export const normalizeAmount = (value: any): number => {
  if (typeof value === 'string') {
    // Remove all non-numeric characters except dots and commas
    const cleaned = value.replace(/[^\d,.-]/g, '');
    // Replace comma with dot for decimal conversion
    const normalized = cleaned.replace(',', '.');
    const numeric = parseFloat(normalized);
    return isNaN(numeric) ? 0 : Math.abs(numeric);
  }
  
  if (typeof value === 'number') {
    return isNaN(value) ? 0 : Math.abs(value);
  }
  
  return 0;
};

/**
 * Normalizes integer values (like dates, installments)
 */
export const normalizeInteger = (value: any): number => {
  if (typeof value === 'string') {
    const numeric = parseInt(value.replace(/\D/g, ''), 10);
    return isNaN(numeric) ? 0 : numeric;
  }
  
  if (typeof value === 'number') {
    return isNaN(value) ? 0 : Math.floor(Math.abs(value));
  }
  
  return 0;
};

/**
 * Validates card data before submission
 */
export const validateCardData = (cardData: any) => {
  const errors: Record<string, string> = {};
  
  if (!cardData.name?.trim()) {
    errors.name = 'Nome do cartão é obrigatório';
  }
  
  if (!cardData.bank?.trim()) {
    errors.bank = 'Banco é obrigatório';
  }
  
  const limit = normalizeAmount(cardData.limit);
  if (limit <= 0) {
    errors.limit = 'Limite deve ser maior que zero';
  }
  
  const dueDate = normalizeInteger(cardData.dueDate);
  if (dueDate < 1 || dueDate > 31) {
    errors.dueDate = 'Data de vencimento deve ser entre 1 e 31';
  }
  
  const closingDate = normalizeInteger(cardData.closingDate);
  if (closingDate < 1 || closingDate > 31) {
    errors.closingDate = 'Data de fechamento deve ser entre 1 e 31';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    normalizedData: {
      ...cardData,
      limit,
      dueDate,
      closingDate
    }
  };
};

/**
 * Validates budget data before submission - UPDATED
 */
export const validateBudgetData = (budgetData: any) => {
  const errors: Record<string, string> = {};
  
  if (!budgetData.categoryId?.trim()) {
    errors.categoryId = 'Categoria é obrigatória';
  }
  
  const amount = normalizeAmount(budgetData.amount);
  if (amount <= 0) {
    errors.amount = 'Valor do orçamento deve ser maior que zero';
  }
  
  if (!budgetData.period?.trim()) {
    errors.period = 'Período é obrigatório';
  }
  
  // O nome agora é gerado automaticamente, não precisa validar
  const name = budgetData.name?.trim() || 'Orçamento';
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    normalizedData: {
      ...budgetData,
      name,
      amount,
      spent: normalizeAmount(budgetData.spent || 0)
    }
  };
};
